import * as React from "react";
import { forwardRef } from "react";
const SvgNavigationPanelRightHide = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={11} viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g stroke="#348CFD" strokeWidth={1.5} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"><path d="M1 5.406h9.834M6.765 1.337l4.069 4.07-4.07 4.068M15.242 9.475V1.337" /></g></svg>;
const ForwardRef = forwardRef(SvgNavigationPanelRightHide);
export { ForwardRef as ReactComponent };